import React from "react";
import "../../css/AdditionalInfoSummary.css";

const AdditionalInfoSummary = ({ additionalInfo }) => {
  return (
    <div className="additional-info-summary">
      <h3>Informacje dodatkowe</h3>
      <div className="additional-info-container">
        <table className="additional-info-table">
          <tbody>
            <tr>
              <td><strong>Miejscowość wyjazdu:</strong></td>
              <td>{additionalInfo.departureCity || "-"}</td>
            </tr>
            <tr>
              <td><strong>Dodatkowe informacje:</strong></td>
              <td>{additionalInfo.departureCityInfo || "-"}</td>
            </tr>
            <tr>
              <td><strong>Dojazd samochodem:</strong></td>
              <td>{additionalInfo.hasCar ? "Tak" : "Nie"}</td>
            </tr>
            {additionalInfo.hasCar && (
              <>
                <tr>
                  <td><strong>Możliwość zabrania dodatkowych osób:</strong></td>
                  <td>{additionalInfo.canTakePassengers ? "Tak" : "Nie"}</td>
                </tr>
                {additionalInfo.canTakePassengers && (
                  <tr>
                    <td><strong>Liczba dodatkowych miejsc:</strong></td>
                    <td>{additionalInfo.passengerCount || "-"}</td>
                  </tr>
                )}
              </>
            )}
            <tr>
              <td><strong>Podróż ze zwierzakiem:</strong></td>
              <td>{additionalInfo.hasPet ? "Tak" : "Nie"}</td>
            </tr>
            {additionalInfo.hasPet && (
              <tr>
                <td><strong>Informacje o zwierzęciu:</strong></td>
                <td>{additionalInfo.petInfo || "-"}</td>
              </tr>
            )}
            {additionalInfo.foodInfo && (
              <tr>
                <td><strong>Informacje o diecie:</strong></td>
                <td>{additionalInfo.foodInfo || "-"}</td>
              </tr>
            )}
            {additionalInfo.userComment && (
              <tr>
                <td><strong>Komentarz użytkownix:</strong></td>
                <td>{additionalInfo.userComment || "-"}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* <div className="additional-info-comment">
        <span className="additional-info-comment-label">Komentarz użytkownix:</span>
        {additionalInfo.userComment || "-"}
      </div> */}
    </div>
  );
};

export default AdditionalInfoSummary;
